/*
 * Funktionen zum Überprüfen der eingelesenen JSON-Daten in allOptions:
 */

export function completeConfigurationsOnly(allOptions) {
    // ggf. Fehler in den Standardkonfigurationen abfangen:
    if (allOptions.length === 0) return
    for (const id in allOptions.defaultConfigurations) {
        let
            thisConfig = allOptions.defaultConfigurations[id],
            errArr = []
        if (!thisConfig.modelId) {
            thisConfig.modelId = id
        }
        if (!thisConfig.width) {
            errArr.push('Breite nicht angegeben')
        }
        if (!thisConfig.frameQuantity) {
            errArr.push('Anzahl nicht angegeben')
        }
        if (!thisConfig.fabricId) {
            errArr.push('Bezugsstoff nicht angegeben')
        }
        if ( (!thisConfig.mattressId) || (!thisConfig.mattressParentId) ) {
            errArr.push('Matratze nicht angegeben')
        } else if (
            (!allOptions.mattressConfiguration.mattresses.find(t => t.articleId === thisConfig.mattressParentId))
            ||
            (!allOptions.mattressConfiguration.mattresses.find(t => t.articleId === thisConfig.mattressParentId).variants.find(v => v.articleId === thisConfig.mattressId)) )
        {
            errArr.push('Matratze nicht gefunden')
        } else if (
            (thisConfig.width * thisConfig.frameQuantity)
            !==
            (allOptions.mattressConfiguration.mattresses.find(t => t.articleId === thisConfig.mattressParentId).variants.find(v => v.articleId === thisConfig.mattressId).width * thisConfig.mattressQuantity)
        ) {
            errArr.push('Größe der Matratze passt nicht zur Konfiguration')
        }
        if ( (!thisConfig.topperId) || (!thisConfig.topperParentId) ) {
            errArr.push('Topper nicht angegeben')
        } else if (
            (!allOptions.mattressConfiguration.toppers.find(t => t.articleId === thisConfig.topperParentId))
            ||
            (!allOptions.mattressConfiguration.toppers.find(t => t.articleId === thisConfig.topperParentId).variants.find(v => v.articleId === thisConfig.topperId))
        ) {
            errArr.push('Topper nicht gefunden')
        } else if (
            (thisConfig.width * thisConfig.frameQuantity)
            !==
            (allOptions.mattressConfiguration.toppers.find(t => t.articleId === thisConfig.topperParentId).variants.find(v => v.articleId === thisConfig.topperId).width * thisConfig.topperQuantity)
        ) {
            errArr.push('Größe des Toppers passt nicht zur Konfiguration')
        }
        if (thisConfig.backId && !allOptions.backParts.find(t => t.articleId === thisConfig.backId)) {
            errArr.push('Rückenteil angegeben, aber nicht gefunden')
        }
        if ( (!thisConfig.feetId) || (!thisConfig.feetParentId) ) {
            errArr.push('Fußsets nicht angegeben')
        } else if (
            (!allOptions.footSets.find(t => t.articleId === thisConfig.feetParentId))
            ||
            (!allOptions.footSets.find(t => t.articleId === thisConfig.feetParentId).variants.find(v => v.articleId === thisConfig.feetId))
        ) {
            errArr.push('Fußset angegeben, aber nicht gefunden')
        }
        if (errArr.length) {
            console.warn('Bettmodell ' + allOptions.models.find(m => m.articleId === id).name + ' (' + id + ') ausgeblendet, da Fehler in den Daten: \n  - ' + errArr.join('\n  - '))
            delete allOptions.defaultConfigurations[id]
        }
        if (!thisConfig.connectorId) {
            thisConfig.connectorId = "49e93b786baaac038004613960f4c524"   // = "ohne Verbinder"
        }
        if (!thisConfig.backQuantity) {
            thisConfig.backQuantity = 1
        }
    }
    return allOptions
}

export function checkStartConfiguration(allOptions) {
    // ggf. Fehler in der Startkonfiguration abfangen:
    if (allOptions.length === 0) return
    if ( (!allOptions.selectedConfiguration) || (!allOptions.selectedConfiguration.modelId) ) {
        // wenn die Startkonfiguration oder deren modelId fehlt, erste Standardkonfiguration verwenden:
        allOptions.selectedConfiguration = allOptions.defaultConfigurations[Object.keys(allOptions.defaultConfigurations)[0]]
        console.warn('Angeforderte Konfiguration fehlt oder ist fehlerhaft - erstes Standardmodell wird angezeigt.')
    }
    if (!allOptions.selectedConfiguration.width) {
        allOptions.selectedConfiguration.width = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].width
        console.warn('Breite für das selektierte Bett fehlt - ersetzt durch Standardwerte des Modells.')
    }
    if (!allOptions.selectedConfiguration.frameQuantity) {
        allOptions.selectedConfiguration.frameQuantity = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].frameQuantity
        console.warn('Bettenanzahl für das selektierte Bett fehlt - ersetzt durch Standardwerte des Modells.')
    }
    if (!allOptions.selectedConfiguration.connectorId) {
        allOptions.selectedConfiguration.connectorId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].connectorId   // = "ohne Verbinder"
    }
    if (!allOptions.selectedConfiguration.fabricId) {
        allOptions.selectedConfiguration.fabricId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].fabricId
        console.warn('Stoff für das selektierte Bett fehlt - ersetzt durch Standardwerte des Modells.')
    }
    if (allOptions.selectedConfiguration.mattressId === allOptions.selectedConfiguration.mattressParentId) {
        // gespeicherte Konfigurationen kennen die OxId der Matratzenvariante nicht, nur die des Vaters, also hier anhand der Breite ermitteln:
        allOptions.mattressConfiguration.mattresses.forEach(function(e) {
            if (e.articleId === allOptions.selectedConfiguration.mattressParentId) {
                e.variants.forEach(function (v) {
                    let selectedMattressWidth = allOptions.selectedConfiguration.width
                    if (allOptions.selectedConfiguration.mattressQuantity < allOptions.selectedConfiguration.frameQuantity) {
                        selectedMattressWidth *= 2
                    }
                    if (selectedMattressWidth === v.width) {
                        allOptions.selectedConfiguration.mattressId = v.articleId
                    }
                })
            }
        })
    }
    if ( (!allOptions.selectedConfiguration.mattressId) || (!allOptions.selectedConfiguration.mattressParentId) ) {
        allOptions.selectedConfiguration.mattressId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].mattressId
        allOptions.selectedConfiguration.mattressParentId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].mattressParentId
        console.warn('Matratzendaten für das selektierte Bett unvollständig - ersetzt durch Standardwerte des Modells.')
    }
    if (allOptions.selectedConfiguration.topperId === allOptions.selectedConfiguration.topperParentId) {
        // gespeicherte Konfigurationen kennen die OxId der Toppervariante nicht, nur die des Vaters, also hier anhand der Breite ermitteln:
        allOptions.mattressConfiguration.toppers.forEach(function(e) {
            if (e.articleId === allOptions.selectedConfiguration.topperParentId) {
                e.variants.forEach(function (v) {
                    let selectedTopperWidth = allOptions.selectedConfiguration.width
                    if (allOptions.selectedConfiguration.topperQuantity < allOptions.selectedConfiguration.frameQuantity) {
                        selectedTopperWidth *= 2
                    }
                    if (selectedTopperWidth === v.width) {
                        allOptions.selectedConfiguration.topperId = v.articleId
                    }
                })
            }
        })
    }
    if ( (!allOptions.selectedConfiguration.topperId) || (!allOptions.selectedConfiguration.topperParentId) ) {
        allOptions.selectedConfiguration.topperId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].topperId
        allOptions.selectedConfiguration.topperParentId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].topperParentId
        console.warn('Topper-Daten für das selektierte Bett unvollständig - ersetzt durch Standardwerte des Modells.')
    }
    if (!allOptions.selectedConfiguration.backQuantity) {
        allOptions.selectedConfiguration.backQuantity = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].backQuantity
        console.warn('Anzahl der Rückenteile für das selektierte Bett fehlt - ersetzt durch Standardwerte des Modells.')
    }
    if (!allOptions.selectedConfiguration.backFabricId) {
        allOptions.selectedConfiguration.backFabricId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].backFabricId
        console.warn('Rückenteil-Stoff für das selektierte Bett fehlt - ersetzt durch Standardwerte des Modells.')
    }
    if ( (!allOptions.selectedConfiguration.feetId) || (!allOptions.selectedConfiguration.feetParentId) ) {
        allOptions.selectedConfiguration.feetId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].feetId
        allOptions.selectedConfiguration.feetParentId = allOptions.defaultConfigurations[allOptions.selectedConfiguration.modelId].feetParentId
        console.warn('Fußset-Daten für das selektierte Bett unvollständig - ersetzt durch Standardwerte des Modells.')
    }
    return allOptions
}